import fetch from '@/util/fetch.js';
import $ from 'jquery'

/**
 * @description http封装成vue插件
 * @author Dy
 * @createDate 2017/9/6 13:45
 */
export default{
  install(Vue)
  {
    /**
     * @description  get请求封装---参数封装
     * @author Dy
     * @createDate 2017/8/4 17:10
     */
    Vue.prototype.$get = function (getUrl, params) {
      return fetch({
        url: getUrl,
        method: 'get',
        params
      });
    }
    /**
     * @description post or get请求封装
     * @author Dy
     * @param reqUrl
     * @param params
     * @param reqMethod
     */
    Vue.prototype.$mergePostAndPut = function (reqUrl, params,reqMethod) {
      if (!reqMethod || reqMethod === ''){
        reqMethod = 'post';
      }
      return fetch({
        url: reqUrl,
        method: reqMethod,
        data: params
      });
    }
    /**
     * @description  导出请求封装
     * @author zc
     * @param reqUrl
     * @param params
     */
    Vue.prototype.$excelRequest = function (reqUrl, params) {
      let myform = $('<form></form>');
      myform.attr('method', 'post')
      myform.attr('action', reqUrl);
      for (let key in params) {
        myform.append('<input type="hidden" name="' + key + '" value="' + params[key] + '" />');
      }
      //根据业务场景封装查询参数
      myform.appendTo('body').submit();
      myform.remove();
    }
    /**
     * @description delete请求删除资源
     * @author Dy
     * @param delUrl
     * @param params
     */
    Vue.prototype.$del = function (delUrl,params) {
      return fetch({
        url: delUrl,
        method: 'delete',
        data: params
      });
    }

    /**
     * @description delete请求删除资源
     * @author Dy
     * @param delUrl
     * @param params
     */
    Vue.prototype.$delBatch = function (delUrl,params) {
      return fetch({
        url: delUrl,
        method: 'delete',
        params
      });
    }

    /**
     * @description get分页请求封装
     * @author Dy
     * @param getUrl
     * @param params
     * @returns {*}
     */
    Vue.prototype.$getForPagination = function (getUrl, params) {
      if (params) {
        if (!params.page) {
          params.page = 1;
        }
        if (!params.limit) {
          params.limit = 2;
        }
      }
      return this.$get(getUrl, params);
    }
  }
};


/**
 * @description http对象
 * @author Dy
 * @createDate 2017/9/6 13:45
 */
export const http = {
  /**
   * @description  get请求封装---参数封装
   * @author Dy
   * @createDate 2017/8/4 17:10
   */

  get(getUrl, params) {
    return fetch({
      url: getUrl,
      method: 'get',
      params
    });
  },
  /**
   * @description post or get请求封装
   * @author Dy
   * @param reqUrl
   * @param params
   * @param reqMethod
   */
  mergePostAndPut(reqUrl, params,reqMethod) {
    if (!reqMethod || reqMethod === ''){
      reqMethod = 'post';
    }
    return fetch({
      url: reqUrl,
      method: reqMethod,
      data: params
    });
  },
  /**
   * @description get分页请求封装
   * @author Dy
   * @param getUrl
   * @param params
   * @returns {*}
   */
  getForPagination(getUrl, params) {
    if (params) {
      if (!params.page) {
        params.page = 1;
      }
      if (!params.limit) {
        params.limit = 10;
      }
    }
    return this.get(getUrl, params);
  },
  /**
   * @description delete请求删除资源
   * @author Dy
   * @param delUrl
   * @param params
   */
  delete(delUrl,params){
    return fetch({
      url: delUrl,
      method: 'delete',
      data: params
    });
  },

  /**
   * 个人提交方式
   * @param reqUrl
   * @param params
   * @param reqMethod
   */
  myPut(reqUrl, params,reqMethod) {
    if (!reqMethod || reqMethod === ''){
      reqMethod = 'post';
    }
    return fetch({
      url: reqUrl,
      method: reqMethod,
      params
    });
  }
};



// WEBPACK FOOTER //
// ./src/api/http.js